import * as React from 'react';
import { withTheme } from 'styled-components';
import { styled } from '../utils/styled';
import { Component } from 'react';
import { propStyles } from '../utils/propStyles';
import { ShareclassColumn } from './ShareclassRows';
import { observer } from 'mobx-react';
import { inject } from '../utils';
import Icon from './Icon';
import { computed } from 'mobx';
import { DataStore, EntityStore, AccessibilityStore } from '../stores';
import { Theme } from '../models/Theme';

const Button = styled<any, any>('button', 'button', 'shareclassRowExpander')`
    ${propStyles};
    all: unset;
`;

Button.defaultProps = {};

interface ShareclassRowExpanderProps {
    theme?: Theme;
    dataStore?: DataStore;
    entityStore?: EntityStore;
    accessibilityStore?: AccessibilityStore;
    labelledby: string;
}
@inject('dataStore', 'accessibilityStore', 'entityStore')
@observer
class ShareclassRowExpander extends Component<ShareclassRowExpanderProps, any> {
    @computed
    get rowExpanderConfig() {
        const { expander } = this.props.dataStore.config.rowConfig;
        return expander;
    }

    render() {
        const {
            theme,
            accessibilityStore,
            entityStore,
            labelledby,
        } = this.props;
        const fileName = entityStore.expanded
            ? this.rowExpanderConfig?.collapseIconFileName || 'CollapseIcon'
            : this.rowExpanderConfig?.expandIconFileName || 'ExpandIcon';

        return (
            <ShareclassColumn
                paddingX="0"
                width="40px"
                textAlign="center"
                {...theme.ShareclassColumnExpand}
            >
                <Button
                    aria-label={accessibilityStore.buttonAccessibilityValue(
                        'ShareclassRowExpander',
                        'Row Expander'
                    )}
                    aria-labelledby={labelledby}
                    aria-expanded={entityStore.expanded}
                    {...theme.ShareclassColumnExpandButton}
                >
                    <Icon
                        iconSize="1.4em"
                        fileName={fileName}
                        aria-hidden={true}
                        {...theme.ShareclassColumnExpandIcon}
                    />
                </Button>
            </ShareclassColumn>
        );
    }
}

export default withTheme(ShareclassRowExpander) as any;



// WEBPACK FOOTER //
// ./src/Components/ShareclassRowExpander.tsx